<template>
    <div v-if="registro" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes do Registro Financeiro</h4>
        <router-link to="/financeiro/registros-financeiros">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <FormSection title="Dados do Registro Financeiro">
          <p><strong>ID:</strong> {{ registro.id }}</p>
          <p>
            <strong>Conta Financeira:</strong>
            {{ registro.conta_financeira_nome || 'Não informado' }}
          </p>
          <p>
            <strong>Data do saldo:</strong>
            {{ formatarData(registro.data) }}
          </p>
          <p>
            <strong>Saldo consolidado:</strong>
            {{ formatarValor(registro.saldo) }}
          </p>
          <p>
            <strong>Criado em:</strong>
            {{ formatarData(registro.criado_em) }}
          </p>
          <p>
            <strong>Atualizado em:</strong>
            {{ formatarData(registro.atualizado_em) }}
          </p>
        </FormSection>
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import axios from '@/services/axios';
  import FormSection from '@/components/Layout/FormSection.vue';
  import globalUtils from '@/utils/globalUtils';
  
  const { formatarData, formatarValor } = globalUtils;
  
  const registro = ref(null);
  const route = useRoute();
  
  async function carregarDetalhesRegistro() {
    try {
      const response = await axios.get(
        `/financeiro/registros-financeiros/${route.params.id}`
      );
      registro.value = response.data;
  
      // Se o registro não trouxer o nome concatenado, busque os dados da conta financeira
      if (registro.value.conta_financeira_id && !registro.value.conta_financeira_nome) {
        const contaResponse = await axios.get(
          `/financeiro/contas-financeiras/${registro.value.conta_financeira_id}`
        );
        registro.value.conta_financeira_nome = `${contaResponse.data.apelido} - ${contaResponse.data.agencia} - ${contaResponse.data.numero_conta}`;
      }
    } catch (error) {
      console.error("Erro ao carregar os detalhes do registro financeiro:", error);
    }
  }
  
  onMounted(() => {
    carregarDetalhesRegistro();
  });
  </script>
  
  <style scoped>
  .card {
    max-width: 90%;
    margin: 0 auto;
  }
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
  }
  
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  
  .form-content {
    margin-top: 1.5rem;
  }
  
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
  